<template>
  <div id="complain-wrap" @click="toggled = false" v-if="info" >
    <div
      class="header"
      v-if="info.avatar"
      :style="{ paddingBottom: toggled ? '' : '15px' }"
      @click.stop="headerClick()"
    >
      <div class="name flexCenterBetween">
        <div class="flexCenterBetween">
          <img :src="info.avatar" alt="" />{{ info.name }}
        </div>
        <div class="r" :class="{ red: info.status == 1 }">
          {{ statusLists[info.status].label }}
        </div>
      </div>
      <div class="com-item">
        <div class="l">投诉金额：</div>
        <div class="r">¥{{ info.fee }}</div>
        <div @click="toggled = !toggled" class="toggle-btn">
          {{ toggled ? "收起" : "投诉详情" }}
          <img
            class="toggle-icon"
            :class="{ active: toggled }"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
            alt=""
          />
        </div>
      </div>
      <template v-if="toggled">
        <div class="com-item">
          <div class="l">投诉时间：</div>
          <div class="r">{{ info.t_create }}</div>
        </div>
        <div class="com-item">
          <div class="l">联系方式：</div>
          <div class="r">{{ info.phone }}</div>
        </div>
        <div
          class="com-item"
          :style="{
            paddingBottom: info.imgs && info.imgs.length ? '' : '15px'
          }"
        >
          <div class="l">投诉原因：</div>
          <div class="r">{{ info.appeal_desc }}</div>
        </div>
        <div class="com-item" v-if="info.imgs && info.imgs.length">
          <div class="l">证据截图：</div>
          <div class="r">
            <div class="img-box">
              <img
                @click="previewImage(index, info.imgs)"
                :src="item"
                v-for="(item, index) in info.imgs"
                :key="index"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="main" @click="toggled = false" v-if="info.lists">
      <div class="first">
        <div class="time">{{ info.t_create }}</div>
        <div class="content">
          <div class="desc">
            <img
              class="success-icon"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220406/de5611e81a4baf50c2d62191cb03a6f3.png"
              alt=""
            />投诉已提交
          </div>
          <div class="tip">已收到您的投诉，请耐心等待处理。</div>
        </div>
      </div>
      <div class="list" v-for="(item, index) in info.lists" :key="index">
        <div class="top" :class="{fr: (!sign && item.leave_type == 1) || (sign && item.leave_type == 0)}" v-if="!item.is_end">
          <img
            class="avatar"
            :src="item.leave_type == 1 ? info.avatar : df_avatar"
            alt=""
          />
          <div class="hander-box">
            <div class="hander">
              {{ item.leave_type == 1 ? (sign ? info.name : '我') : "系统回复" }}
              {{ sign && item.leave_type == 0 ? " (" + item.operator + ")" : "" }}
            </div>
            <div class="time">{{ item.t_create }}</div>
            <div class="content">
              <div class="desc">{{ item.desc }}</div>
              <div class="img-box" v-if="item.imgs && item.imgs.length">
                <img
                  style="margin: 10px 10px 0 0"
                  @click="previewImage(sindex, item.imgs)"
                  :src="sitem"
                  v-for="(sitem, sindex) in item.imgs"
                  :key="sindex"
                  alt=""
                />
              </div>
            </div>
          </div>
          <img
            class="avatar opa"
            :src="item.leave_type == 1 ? info.avatar : df_avatar"
            alt=""
          />
        </div>
        <div class="last" v-else>
          <div class="time">{{ item.t_create }}</div>
          <div class="content">
            <div class="desc"><img
              class="success-icon"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220406/de5611e81a4baf50c2d62191cb03a6f3.png"
              alt=""
            />已发起退款</div>
            <div class="tip">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" v-if="info.status != 3 || (info.status == 3 && sign)" @click="toggled = false">
      <div class="btn l" v-if="info.status != 3" @click="cancel">{{ sign ? "退款" : "撤回投诉" }}</div>
      <div class="btn r" @click="reply">{{ sign ? "系统回复" : "留言" }}</div>
    </div>
    <van-popup
      z-index="90"
      v-model="visible"
      position="bottom"
      duration="0.1"
      :style="{ borderRadius: '4px 4px 0 0' }"
    >
      <div class="pop-box">
        <div class="pop-box-wrap">
          <div class="title">
          {{
            pop_type == 1
              ? "是否确认退款"
              : pop_type == 2
              ? "是否确认撤回本次投诉"
              : "留言"
          }}
        </div>
        <div class="push-desc" v-if="pop_type == 1">
          确定后给用户推送提示：已提交退款申请
        </div>
        <div class="cancel-tip" v-if="pop_type == 2">
          请确认此申请已处理或无需处理，请依据实际情况点击下方按钮。
        </div>
        <template v-if="pop_type < 2">
          <textarea
            class="fill-textarea"
            v-model="desc"
            maxlength="200"
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="请输入内容"
          ></textarea>
          <div style="margin-top: 10px;" v-if="pop_type != 1">
            <van-uploader
              class="custom-uploader"
              :deletable="false"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="4"
              multiple
              accept="image/png, image/jpeg"
              v-model="imgList"
            >
              <template #preview-cover="{ file }">
                <div
                  @click.stop="deletePic(file)"
                  class="preview-cover van-ellipsis"
                >
                  删除
                </div>
              </template>
              <div class="pic-item">
                <img :src="coverImg" class="pic" />
                <span class="desc">图片</span>
              </div>
            </van-uploader>
          </div>
        </template>
        <template v-else>
          <div class="name flexCenterBetween" style="margin-top: 30px">
            <div class="flexCenterBetween">
              <img :src="info.avatar" alt="" />{{ info.name }}
            </div>
          </div>
          <div class="com-item">
            <div class="l">投诉金额：</div>
            <div class="r">¥{{ info.fee }}</div>
          </div>
          <template>
            <div class="com-item">
              <div class="l">投诉时间：</div>
              <div class="r">{{ info.t_create }}</div>
            </div>
            <div class="com-item">
              <div class="l">联系方式：</div>
              <div class="r">{{ info.phone }}</div>
            </div>
            <div class="com-item">
              <div class="l">投诉原因：</div>
              <div class="r">{{ info.appeal_desc }}</div>
            </div>
            <div class="com-item">
              <div class="l">证据截图：</div>
              <div class="r">
                <div class="img-box" v-if="info.imgs && info.imgs.length">
                  <img
                    @click="previewImage(index, info.imgs)"
                    :src="item"
                    v-for="(item, index) in info.imgs"
                    :key="index"
                    alt=""
                  />
                </div>
                <div class="no-img" v-else>无</div>
              </div>
            </div>
          </template>
        </template>

        <div class="btn-group">
          <div class="btn l" @click="visible = false">
            {{ pop_type == 2 ? "不撤回" : "取消" }}
          </div>
          <div
            class="btn"
            @click="confirmClick"
            :class="{ red: pop_type == 1, unable: pop_type == 2 }"
          >
            {{
              pop_type == 0 ? "发送" : pop_type == 1 ? "确定退款" : "撤回投诉"
            }}
          </div>
        </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getToken, reLogin } from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import { Toast, ImagePreview } from "vant";
import uploadHttp from "@/utils/picOnly";
import api from "@/utils/api";
import * as imageConversion from "image-conversion";

export default {
  data() {
    return {
      sign: "",
      pop_type: 0, // 0留言 1、退款 2、撤回投诉
      desc: "",
      visible: false,
      appeal_name: "",
      appeal_desc: "",
      imgs: [],
      order_id: "",
      phone: "",
      imgList: [],
      info: {},
      toggled: false,
      coverImg:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-04-15/c1bac5721a0cfa68ef8cea2b7d239649.svg",
      statusLists: [
        { label: "无状态", value: 0 },
        { label: "待处理", value: 1 },
        { label: "处理中", value: 2 },
        { label: "已结束", value: 3 }
      ],
      df_avatar:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-09-18/a3295cae8d95b5af09a41f4d89d2fb91.jpg"
    };
  },
  mounted() {
    document.title = '投诉';
    if (this.$route.query.no) {
      this.order_id = this.$route.query.no;
      if (this.$route.query.sign) {
        this.sign = this.$route.query.sign;
      }
      if(this.$route.query.ut) {
        localStorage.setItem("token", this.$route.query.ut);
        localStorage.setItem('orderDirect', 1)
      }else {
        localStorage.setItem('orderDirect', 0)
      }
      this.getDetail();
    }
  },
  methods: {
    headerClick() {},
    // 回复
    reply() {
      if(this.pop_type == 1) {
        this.desc = '';
      }
      this.pop_type = 0;
      this.visible = true;
    },
    // 退款 | 撤回投诉
    cancel() {
      this.pop_type = this.sign ? 1 : 2;
      if(this.sign) {
        this.desc = '预计2个工作日内原路退回，若有其他疑问可联系客服咨询。'
        this.imgList = [];
        this.imgs = [];
      }
      this.visible = true;
    },
    confirmClick() {
      if (this.pop_type == 0) {
        // 留言
        this.save();
      } else if (this.pop_type == 1) {
        // 退款
        this.save();
      } else if (this.pop_type == 2) {
        this.cancelClick();
        // 撤回投诉
      }
    },
    save() {
      if (this.desc == "") {
        return Toast("请填写内容");
      }
      let param = {
        order_id: this.order_id,
        appeal_id: this.appeal_id,
        desc: this.desc,
        ...(this.imgs && this.imgs.length
          ? { imgs: this.imgs.map(item => item.img) }
          : {}),
        ...(this.sign
          ? {
              sign: this.sign,
              is_end: this.info.status == 3 ? 2 : this.pop_type == 1  ? 1 : 0
            }
          : { access_token: getToken() })
      };
      let url = this.sign ? "/admin" : "";
      questionOnly
        .post("/xcx/ques/v1/order/appeal/leave" + url, param)
        .then(res => {
          if (res.sta == 0) {
            this.getDetail();
            this.clearInput();
          } else if (res.sta === -500) {
            reLogin();
          } else {
            Toast(res.msg);
          }
        });
    },
    clearInput() {
      this.visible = false;
      this.imgs = [];
      this.imgList = [];
      this.desc = "";
    },
    // 撤回投诉
    cancelClick() {
      let param = {
        order_id: this.order_id,
        appeal_id: this.appeal_id,
        access_token: getToken()
      };
      questionOnly.post("/xcx/ques/v1/order/appeal/recall", param).then(res => {
        if (res.sta == 0) {
          let {
            fee,
            name,
            avatar,
            t_create,
            phone,
            appeal_desc,
            imgs
          } = this.info;
          let complainData = {
            fee,
            name,
            avatar,
            t_create,
            phone,
            appeal_desc,
            imgs
          };
          localStorage.setItem("complainData", JSON.stringify(complainData));
          this.$router.replace({
            name: "withdraw"
          });
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    deletePic(file) {
      this.imgList = this.imgList.filter(item => item.file !== file);
      this.imgs = this.imgs.filter(item => item.file !== file);
    },
    beforeRead(files) {
      this.$store.commit("changeLoading", { status: true, text: "图片上传中" });
      if (files.length) {
        const compressPromises = [];
        for (const file of files) {
          const isLt1M = (file.size / 1024 / 1024) * 10 < 5;
          if (!isLt1M) {
            compressPromises.push(
              new Promise(resolve => {
                // 压缩到500KB,这里的500就是要压缩的大小,可自定义
                imageConversion.compressAccurately(file, 500).then(res => {
                  resolve(res);
                });
              })
            );
          } else {
            compressPromises.push(Promise.resolve(file));
          }
        }
        return Promise.all(compressPromises);
      } else {
        const isLt1M = (files.size / 1024 / 1024) * 10 < 5;
        if (!isLt1M) {
          let myImg = new Promise(resolve => {
            // 压缩到500KB,这里的500就是要压缩的大小,可自定义
            imageConversion.compressAccurately(files, 500).then(res => {
              resolve(res);
            });
          });
          return myImg;
        }
        return true;
      }
    },
    afterRead(files) {
      var url = api.question.upload;
      let formData = new window.FormData();
      // 判断是单张还是多张图片
      if (Array.isArray(files)) {
        // 多张图片
        for (const file of files) {
          formData.append("file", file.file);
        }
      } else {
        // 单张图片
        formData.append("file", files.file);
      }
      formData.append("access_token", this.sign ? this.info.cc : getToken());
      try {
        uploadHttp.post(url, formData).then(res => {
          if (Array.isArray(files)) {
            // 多张图片
            for (let i = 0; i < files.length; i++) {
              this.imgs.push({ file: files[i].file, img: res.data.urls[i] });
            }
          } else {
            // 单张图片
            this.imgs.push({ file: files.file, img: res.data.urls[0] });
          }
          this.$store.commit("changeLoading", { status: false });
        });
      } catch (e) {
        this.$store.commit("changeLoading", { status: false });
      }
    },
    previewImage(index, targetImg) {
      ImagePreview({
        images: targetImg,
        closeable: true,
        startPosition: index
      });
    },
    getDetail() {
      let param = {
        order_id: this.order_id,
        page: 1,
        count: 20,
        ...(this.sign ? { sign: this.sign } : { access_token: getToken() })
      };
      questionOnly.get("/xcx/ques/v1/order/appeal/detail", param).then(res => {
        if (res.sta == 0) {
          this.info = res.data;
          this.appeal_id = res.data.appeal_id;
          if(res.data.lists && res.data.lists.length) {
            setTimeout(()=> {
              window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth'
              });
            }, 10)
          }
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#complain-wrap{
  margin: 0 auto;
  max-width: 500px;
  min-width: 320px;
  position: relative;
  min-height: calc(100vh - 192px);
  margin-bottom: 76px;
  padding-bottom: env(safe-area-inset-bottom);
  // height: 100vh;
  // overflow-y: scroll;
}
.header {
  background: #ffffff;
  padding: 15px 15px 0;
  position: fixed;
  left: auto;
  top: 0;
  max-width: 500px;
  min-width: 320px;
  width: 100%;
  z-index: 9;
  box-sizing: border-box;
  // padding-bottom: env(safe-area-inset-bottom);
}
.main {
  margin: 116px 0 0;
  // padding-bottom: 84px;
  max-width: 500px;
  min-width: 320px;
  .list:last-child {
    margin-bottom: 10px;
  }
}
.name {
  height: 30px;
  font-size: 14px;
  margin-bottom: 15px;
  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
  }
  .r {
    font-size: 13px;
    color: #999999;
  }
  .red {
    color: #ff0000;
  }
}
.com-item {
  display: flex;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 10px;
  position: relative;
  .l {
    color: #999999;
    min-width: 70px;
  }
  .r {
    flex: 1;
    white-space: pre-line;
  }
  .no-img {
    color: #999999;
  }
}
.img-box {
  display: flex;
  flex-wrap: wrap;
  img {
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 15px;
    &:last-child {
      margin-right: 0 !important;
    }
  }
  
}
.com-item:last-child {
  margin-bottom: 0;
}
.toggle-btn {
  position: absolute;
  right: 0;
  top: -2px;
  font-size: 13px;
  color: #999999;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.toggle-icon {
  width: 8px;
  height: 12px;
  transform: rotate(90deg);
  transition: 0.3s all ease;
  margin-left: 5px;
}
.toggle-icon.active {
  transform: rotate(-90deg);
}
.first,
.last {
  .time {
    text-align: center;
  }
  .content {
    margin-top: 20px;
    background: #ffffff;
    margin: 20px 15px;
    padding: 15px;
    border-radius: 4px;
    .desc {
      font-size: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eeeeee;
      white-space: pre-line;
      display: flex;
      align-items: center;
    }
    .tip {
      font-size: 13px;
      color: #999999;
      padding-top: 10px;
      white-space: pre-line;
    }
  }
}
.time {
  font-size: 13px;
  color: #999999;
}
.list {
  .top {
    display: flex;
    margin: 0 15px;
    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      object-fit: cover;
    }
    .opa {
      opacity: 0;
    }
    .hander-box {
      margin: 0 10px 20px;
      // flex: 1;
      .hander {
        font-size: 14px;
      }
    }
    .content {
      flex: 1;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      font-size: 14px;
      margin-top: 10px;
      display: inline-block;
      float: left;
      .desc {
        white-space: pre-line;
      }
    }
  }
  .fr {
    flex-direction: row-reverse;
    .hander, .time {
      text-align: right;
    }
    .content {
      float: right;
    }
  }
}
.success-icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.foot {
  left: auto;
  max-width: 500px;
  min-width: 320px;
  background: #ffffff;
  border-top: 1px solid #eee;
  display: flex;
  box-sizing: border-box;
  z-index: 90;
  align-items: center;
  padding: 15px;
  padding-bottom: calc(15px + env(safe-area-inset-bottom));
  .btn {
    flex: 1;
    border-radius: 4px;
    height: 45px;
    background: #06c05f;
    color: #ffffff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .l {
    margin-right: 15px;
    background: #f6f6f6;
    color: #666666;
  }
  .r {
  }
}
.pop-box {
  width: 100%;
  position: fixed;
  z-index: 4;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  .pop-box-wrap {
    position: relative;
    width: 100%;
    max-width: 500px;
    padding: 20px 15px 0;
    background-color: #ffffff;
    border-radius: 10px 10px 0 0;
    box-sizing: border-box;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .title {
    font-size: 17px;
    font-weight: bold;
  }
  .push-desc {
    font-size: 15px;
    color: #999999;
    margin-top: 15px;
  }
  .cancel-tip {
    margin-top: 5px;
    font-size: 14px;
    color: #999999;
  }
  .fill-textarea {
    border: 0;
    font-size: 14px;
    height: 120px;
    padding: 10px;
    background: #f6f6f6;
    margin-top: 15px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
  }
  .upload-box {
    width: 70px;
    height: 70px;
    overflow: hidden;
    box-sizing: border-box;
  }
  .pickers {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/ .custom-uploader .van-uploader__file {
    width: 70px;
    height: 70px;
  }
  /deep/ .van-uploader__preview-image {
    width: 70px;
    height: 70px;
  }
  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    color: #fff;
    font-size: 12px;
    text-align: center;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 0.42);
    border-radius: 0 0 2px 2px;
  }

  .picture {
    width: 70px;
    height: 70px;
    object-fit: cover;
  }

  .pic-item {
    width: 70px;
    height: 70px;
    position: relative;
    background-color: #f6f6f6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
    color: #999999;
    margin-right: 10px;
  }

  .pic-item:first-child {
    margin-left: 0;
  }

  .pic-item.active {
    width: 20px;
    height: 20px;
  }

  .delete-pic {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.42);
    border-radius: 0 0 2px 2px;
    color: #fff;
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    text-align: center;
  }

  .pic {
    width: 30px;
    height: 30px;
  }

  .camera-box {
    margin-bottom: 10px;
    padding: 15px;
  }
  .btn-group {
    display: flex;
    margin: 15px 0;
    .btn {
      flex: 1;
      border-radius: 4px;
      height: 45px;
      background: #06c05f;
      color: #ffffff;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .l {
      margin-right: 15px;
      background: #f6f6f6;
      color: #666666;
    }
    .red {
      background: #ff7070;
    }
    .unable {
      background: #f6f6f6;
      color: #666666;
    }
  }
}
textarea::-webkit-resizer {
  display: none;
}
textarea::-moz-resizer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/complainlist.vue